import { render, staticRenderFns } from "./title-2.vue?vue&type=template&id=3ae4213e&scoped=true"
import script from "./title-2.vue?vue&type=script&lang=js"
export * from "./title-2.vue?vue&type=script&lang=js"
import style0 from "./title-2.vue?vue&type=style&index=0&id=3ae4213e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae4213e",
  null
  
)

export default component.exports